import styled from 'styled-components';

import { getTheme } from 'lib/styles/getTheme';

export const Label = styled.label`
  font-family: ${getTheme('text.fontFamily')};
`;
